module.exports = __webpack_public_path__ + "static/media/delantal (2).5f02ae0f.jpg";